export const errorControlMixin = {
  data: () => ({}),
  methods: {
    errorControl(error) {
      console.log(error);

      let errorMessage = '처리 중 문제가 발생했습니다. 관리자에게 문의 바랍니다.';

      if (error?.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      return this.$dialog.message.warning(errorMessage, {position: 'top', timeout: 1500});
    },
  },
};
